import api from './client';

export interface Service {
  id: number;
  name: string;
  default_price?: number | null;
  unit: string;
  default_warranty_days?: number | null;
  notes?: string | null;
  sort_order: number;
  is_active: boolean;
}

export interface ServiceListResponse {
  items: Service[];
  total: number;
  page: number;
  per_page: number;
}

export interface ServicePayload {
  name: string;
  default_price?: number | null;
  unit?: string;
  default_warranty_days?: number | null;
  notes?: string | null;
  sort_order?: number;
  is_active?: boolean;
}

export interface ServiceListParams {
  page?: number;
  per_page?: number;
  search?: string;
  include_inactive?: boolean;
}

export const listServices = (params: ServiceListParams = {}): Promise<ServiceListResponse> =>
  api.get<ServiceListResponse>('/service-catalog', { params }).then((r) => r.data);

export const getService = (id: number): Promise<Service> =>
  api.get<Service>(`/service-catalog/${id}`).then((r) => r.data);

export const createService = (data: ServicePayload): Promise<Service> =>
  api.post<Service>('/service-catalog', data).then((r) => r.data);

export const updateService = (id: number, data: Partial<ServicePayload>): Promise<Service> =>
  api.put<Service>(`/service-catalog/${id}`, data).then((r) => r.data);

export const archiveService = (id: number): Promise<void> =>
  api.delete(`/service-catalog/${id}`).then(() => undefined);
